import { createFileRoute } from "@tanstack/react-router";
import ContactPage from "@project/user/pages/contact/index";

export const Route = createFileRoute("/_user/contact")({
  head: () => ({ meta: [{ title: "Contact — Jivandhara" }] }),
  component: ContactPage,
});
